import React, { useState, useEffect } from 'react';
import { FaTruck, FaBox, FaClock, FaCheck, FaExclamationTriangle, FaEye, FaSync, FaFilter, FaCalendarAlt, FaMapMarkerAlt, FaDollarSign, FaWrench, FaCog } from 'react-icons/fa';
import Badge from '@/components/common/Badge';
import Card, { CardBody } from '@/components/common/Card';
import Button from '@/components/common/Button';
import Modal from '@/components/common/Modal';
import FilterBar from '@/components/common/FilterBar';
import CustomSelect from '@/components/common/CustomSelect';
import toastService from '@/utils/toastService';

/**
 * Sistema de seguimiento de órdenes de teknoParts
 * Permite hacer tracking de repuestos pedidos al proveedor exclusivo
 */
const SeguimientoOrdenesExternas = () => {
  const [loading, setLoading] = useState(false);
  const [ordenes, setOrdenes] = useState([]);
  const [filteredOrdenes, setFilteredOrdenes] = useState([]);
  const [selectedOrden, setSelectedOrden] = useState(null);
  const [showDetalleModal, setShowDetalleModal] = useState(false);
  const [showInventarioModal, setShowInventarioModal] = useState(false);
  const [ordenParaInventario, setOrdenParaInventario] = useState(null);

  // Filtros (sin filtro por proveedor ya que solo tenemos teknoParts)
  const [filters, setFilters] = useState({
    estado: '',
    fechaDesde: '',
    fechaHasta: '',
    searchTerm: ''
  });

  // Mock data de órdenes
  const mockOrdenes = [
    {
      id: 'ORD-2025-001',
      fecha_pedido: '2025-01-25T10:30:00Z',
      fecha_entrega_estimada: '2025-01-26T18:00:00Z',
      fecha_entrega_real: '2025-01-26T16:45:00Z',
      estado: 'entregado',
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png',
        telefono: '+56 2 2345 6789',
        email: 'ordenes@teknoparts.cl'
      },
      mantenimiento_id: 'MANT-2025-045',
      numero_orden_proveedor: 'SHOP-789123456',
      total: 157000,
      comision_aplicada: 7850,
      items: [
        {
          id: 1,
          nombre: 'Filtro de Aceite Toyota Premium',
          codigo_proveedor: 'FO-TOY-PREM-2024',
          cantidad: 2,
          precio_unitario: 24000,
          precio_final: 32000,
          imagen: 'https://proveedor.com/images/filtro-toyota-premium.jpg'
        },
        {
          id: 2,
          nombre: 'Kit Pastillas de Freno Performance',
          codigo_proveedor: 'PF-PERFORMANCE-KIT',
          cantidad: 1,
          precio_unitario: 65000,
          precio_final: 85000,
          imagen: 'https://proveedor.com/images/pastillas-performance.jpg'
        }
      ],
      tracking: {
        numero_guia: 'CH789456123',
        transportista: 'StarKen',
        url_tracking: 'https://starken.cl/seguimiento/CH789456123'
      },
      historial: [
        {
          fecha: '2025-01-25T10:30:00Z',
          estado: 'pendiente',
          descripcion: 'Orden creada automáticamente desde la plataforma',
          usuario: 'Sistema'
        },
        {
          fecha: '2025-01-25T11:15:00Z',  
          estado: 'en_proceso',
          descripcion: 'Proveedor confirmó disponibilidad y procesó la orden',
          usuario: 'teknoParts'
        },
        {
          fecha: '2025-01-25T14:30:00Z',
          estado: 'en_proceso',
          descripcion: 'Orden en preparación en bodega del proveedor',
          usuario: 'teknoParts'
        },
        {
          fecha: '2025-01-26T09:00:00Z',
          estado: 'en_proceso',
          descripcion: 'Pedido despachado con StarKen - Guía CH789456123',
          usuario: 'teknoParts'
        },
        {
          fecha: '2025-01-26T16:45:00Z',
          estado: 'entregado',
          descripcion: 'Entregado exitosamente en Taller San Martín',
          usuario: 'StarKen'
        }
      ]
    },
    {
      id: 'ORD-2025-002',
      fecha_pedido: '2025-01-26T14:20:00Z',
      fecha_entrega_estimada: '2025-01-29T18:00:00Z',
      fecha_entrega_real: null,
      estado: 'en_proceso',
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png',
        telefono: '+56 2 2345 6789',
        email: 'ordenes@teknoparts.cl'
      },
      mantenimiento_id: 'MANT-2025-046',
      numero_orden_proveedor: 'SHOP-789123457',
      total: 125000,
      comision_aplicada: 6250,
      items: [
        {
          id: 3,
          nombre: 'Amortiguador Delantero Izquierdo',
          codigo_proveedor: 'AM-MONROE-DEL-L',
          cantidad: 1,
          precio_unitario: 95000,
          precio_final: 125000,
          imagen: 'https://proveedor.com/images/amortiguador.jpg'
        }
      ],
      tracking: {
        numero_guia: 'CH789456124',
        transportista: 'StarKen',
        url_tracking: 'https://starken.cl/seguimiento/CH789456124'
      },
      historial: [
        {
          fecha: '2025-01-26T14:20:00Z',
          estado: 'pendiente',
          descripcion: 'Orden creada automáticamente desde la plataforma',
          usuario: 'Sistema'
        },
        {
          fecha: '2025-01-26T15:30:00Z',
          estado: 'en_proceso',
          descripcion: 'Proveedor confirmó disponibilidad y procesó la orden',
          usuario: 'teknoParts'
        },
        {
          fecha: '2025-01-27T10:00:00Z',
          estado: 'en_proceso', 
          descripcion: 'Orden en preparación en bodega del proveedor',
          usuario: 'teknoParts'
        },
        {
          fecha: '2025-01-28T11:30:00Z',
          estado: 'en_proceso',
          descripcion: 'Pedido despachado con StarKen - Guía CH789456124',
          usuario: 'teknoParts'
        }
      ]
    },
    {
      id: 'ORD-2025-003',
      fecha_pedido: '2025-01-27T09:45:00Z',
      fecha_entrega_estimada: '2025-01-30T18:00:00Z',
      fecha_entrega_real: null,
      estado: 'cancelado',
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png',
        telefono: '+56 2 2456 7890',
        email: 'ordenes@teknoparts.cl'
      },
      mantenimiento_id: 'MANT-2025-047',
      numero_orden_proveedor: 'TKP-456789',
      total: 85000,
      comision_aplicada: 4250,
      items: [
        {
          id: 4,
          nombre: 'Bomba de Agua Universal',
          codigo_proveedor: 'TKP-BA-UNIV-2024',
          cantidad: 1,
          precio_unitario: 65000,
          precio_final: 85000,
          imagen: 'https://images.unsplash.com/photo-1558618047-8c0c2a0a6e3f?w=300&h=200&fit=crop&auto=format'
        }
      ],
      tracking: null,
      problema: {
        tipo: 'stock_agotado',
        descripcion: 'Producto temporalmente agotado en teknoParts',
        fecha_reporte: '2025-01-28T10:00:00Z',
        acciones_sugeridas: [
          'Esperar reposición (estimado 3-5 días)',
          'Solicitar repuesto alternativo',
          'Cancelar orden y reembolsar'
        ]
      },
      historial: [
        {
          fecha: '2025-01-27T09:45:00Z',
          estado: 'pendiente',
          descripcion: 'Orden creada automáticamente desde la plataforma',
          usuario: 'Sistema'
        },
        {
          fecha: '2025-01-27T16:00:00Z',
          estado: 'en_proceso',
          descripcion: 'Proveedor confirmó la orden inicialmente',
          usuario: 'teknoParts'
        },
        {
          fecha: '2025-01-28T10:00:00Z',
          estado: 'cancelado',
          descripcion: 'teknoParts reportó stock agotado tras verificación física',
          usuario: 'teknoParts'
        }
      ]
    },
    {
      id: 'ORD-2025-004',
      fecha_pedido: '2025-01-28T11:00:00Z',
      fecha_entrega_estimada: '2025-01-29T18:00:00Z',
      fecha_entrega_real: null,
      estado: 'pendiente',
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png',
        telefono: '+56 2 2345 6789',
        email: 'ordenes@teknoparts.cl'
      },
      mantenimiento_id: null, // Orden independiente
      numero_orden_proveedor: 'SHOP-789123458',
      total: 45000,
      comision_aplicada: 2250,
      items: [
        {
          id: 5,
          nombre: 'Sensor de Temperatura Coolant',
          codigo_proveedor: 'SENS-TEMP-COOL',
          cantidad: 1,
          precio_unitario: 28000,
          precio_final: 35000,
          imagen: 'https://proveedor.com/images/sensor-temp-coolant.jpg'
        }
      ],
      tracking: null,
      historial: [
        {
          fecha: '2025-01-28T11:00:00Z',
          estado: 'pendiente',
          descripcion: 'Orden creada automáticamente desde la plataforma',
          usuario: 'Sistema'
        },
        {
          fecha: '2025-01-28T12:30:00Z',
          estado: 'en_proceso',
          descripcion: 'Proveedor confirmó disponibilidad y procesó la orden',
          usuario: 'teknoParts'
        }
      ]
    }
  ];

  const estadosOrden = {
    pendiente: { label: 'Pendiente', variant: 'warning', icon: FaClock },
    en_proceso: { label: 'En Proceso', variant: 'primary', icon: FaTruck },
    entregado: { label: 'Entregado', variant: 'success', icon: FaCheck },
    cancelado: { label: 'Cancelado', variant: 'danger', icon: FaExclamationTriangle }
  };

  // Solo tenemos teknoParts como proveedor exclusivo

  useEffect(() => {
    fetchOrdenes();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [ordenes, filters]);

  const fetchOrdenes = async () => {
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      setOrdenes(mockOrdenes);
    } catch (error) {
      toastService.error('Error al cargar órdenes');
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...ordenes];

    // Filtro por estado
    if (filters.estado) {
      filtered = filtered.filter(orden => orden.estado === filters.estado);
    }

    // Filtro por proveedor removido - solo tenemos teknoParts

    // Filtro por término de búsqueda
    if (filters.searchTerm) {
      const term = filters.searchTerm.toLowerCase();
      filtered = filtered.filter(orden =>
        orden.id.toLowerCase().includes(term) ||
        orden.numero_orden_proveedor.toLowerCase().includes(term) ||
        (orden.mantenimiento_id && orden.mantenimiento_id.toLowerCase().includes(term)) ||
        orden.items.some(item => 
          item.nombre.toLowerCase().includes(term) ||
          item.codigo_proveedor.toLowerCase().includes(term)
        )
      );
    }

    // Filtros por fecha
    if (filters.fechaDesde) {
      filtered = filtered.filter(orden => 
        new Date(orden.fecha_pedido) >= new Date(filters.fechaDesde)
      );
    }

    if (filters.fechaHasta) {
      filtered = filtered.filter(orden => 
        new Date(orden.fecha_pedido) <= new Date(filters.fechaHasta + 'T23:59:59')
      );
    }

    // Ordenar por fecha más reciente
    filtered.sort((a, b) => new Date(b.fecha_pedido) - new Date(a.fecha_pedido));

    setFilteredOrdenes(filtered);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleVerDetalle = (orden) => {
    setSelectedOrden(orden);
    setShowDetalleModal(true);
  };

  const handleSyncOrden = async (ordenId) => {
    try {
      toastService.info('Sincronizando estado de la orden...');
      // Simular sync con teknoParts
      await new Promise(resolve => setTimeout(resolve, 1500));
      toastService.success('Estado actualizado desde teknoParts');
      fetchOrdenes();
    } catch (error) {
      toastService.error('Error al sincronizar');
    }
  };

  const handleAgregarAInventario = (orden) => {
    setOrdenParaInventario(orden);
    setShowInventarioModal(true);
  };

  const formatFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getEstadoInfo = (estado) => {
    return estadosOrden[estado] || estadosOrden.pedido_creado;
  };

  const calcularTiempoTranscurrido = (fechaPedido) => {
    const ahora = new Date();
    const fecha = new Date(fechaPedido);
    const diffMs = ahora - fecha;
    const diffHoras = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDias = Math.floor(diffHoras / 24);

    if (diffDias > 0) {
      return `Hace ${diffDias} día${diffDias > 1 ? 's' : ''}`;
    } else if (diffHoras > 0) {
      return `Hace ${diffHoras} hora${diffHoras > 1 ? 's' : ''}`;
    } else {
      return 'Hace menos de 1 hora';
    }
  };

  const getEstadoStats = () => {
    const stats = {};
    Object.keys(estadosOrden).forEach(estado => {
      stats[estado] = ordenes.filter(orden => orden.estado === estado).length;
    });
    return stats;
  };

  const stats = getEstadoStats();

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <div className="w-1 h-6 rounded-full mr-3 bg-green-500" />
          <h1 className="text-2xl font-bold">Seguimiento de Órdenes Externas</h1>
        </div>
        
        {/* Solo en escritorio: Stats inline con botón */}
        <div className="hidden lg:flex items-center flex-1 justify-center gap-3 mx-6">
          {Object.entries(estadosOrden).map(([estado, info]) => (
            <Card 
              key={estado}
              className={`bg-${info.variant === 'primary' ? 'blue' : 
                           info.variant === 'success' ? 'green' :
                           info.variant === 'warning' ? 'yellow' :
                           info.variant === 'danger' ? 'red' :
                           info.variant === 'info' ? 'blue' : 'gray'}-900/20 
                          border-${info.variant === 'primary' ? 'blue' : 
                                  info.variant === 'success' ? 'green' :
                                  info.variant === 'warning' ? 'yellow' :
                                  info.variant === 'danger' ? 'red' :
                                  info.variant === 'info' ? 'blue' : 'gray'}-800/50 w-36`}
            >
              <CardBody className="px-4 py-2">
                <div className="text-center">
                  <p className="text-xs text-gray-400 mb-1">{info.label}</p>
                  <div className="flex items-center justify-center">
                    <info.icon className={`text-${info.variant === 'primary' ? 'blue' : 
                                               info.variant === 'success' ? 'green' :
                                               info.variant === 'warning' ? 'yellow' :
                                               info.variant === 'danger' ? 'red' :
                                               info.variant === 'info' ? 'blue' : 'gray'}-400 text-xl mr-2`} />
                    <p className="text-xl font-bold">{stats[estado] || 0}</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          ))}
          
        </div>
        
        {/* Botón para escritorio */}
        <div className="hidden lg:block">
          <Button
            variant="secondary"
            onClick={fetchOrdenes}
            loading={loading}
            icon={<FaSync />}
          >
            Actualizar
          </Button>
        </div>
        
        {/* Solo en móvil/tablet: Botón separado */}
        <div className="lg:hidden">
          <Button
            variant="secondary"
            onClick={fetchOrdenes}
            loading={loading}
            icon={<FaSync />}
          >
            Actualizar
          </Button>
        </div>
      </div>

      {/* Stats rápidas - solo en móvil/tablet */}
      <div className="lg:hidden grid grid-cols-2 gap-4 mb-6">
        {Object.entries(estadosOrden).map(([estado, info]) => (
          <Card 
            key={estado}
            className={`bg-${info.variant === 'primary' ? 'blue' : 
                         info.variant === 'success' ? 'green' :
                         info.variant === 'warning' ? 'yellow' :
                         info.variant === 'danger' ? 'red' :
                         info.variant === 'info' ? 'blue' : 'gray'}-900/20 
                        border-${info.variant === 'primary' ? 'blue' : 
                                info.variant === 'success' ? 'green' :
                                info.variant === 'warning' ? 'yellow' :
                                info.variant === 'danger' ? 'red' :
                                info.variant === 'info' ? 'blue' : 'gray'}-800/50`}
          >
            <CardBody className="p-3">
              <div className="text-center">
                <p className="text-xs text-gray-400 mb-1">{info.label}</p>
                <div className="flex items-center justify-center">
                  <info.icon className={`text-${info.variant === 'primary' ? 'blue' : 
                                             info.variant === 'success' ? 'green' :
                                             info.variant === 'warning' ? 'yellow' :
                                             info.variant === 'danger' ? 'red' :
                                             info.variant === 'info' ? 'blue' : 'gray'}-400 text-xl mr-2`} />
                  <p className="text-xl font-bold">{stats[estado] || 0}</p>
                </div>
              </div>
            </CardBody>
          </Card>
        ))}
      </div>

      {/* Filtros */}
      <FilterBar
        onSearch={(value) => setFilters({...filters, searchTerm: value})}
        searchValue={filters.searchTerm}
        onReset={() => setFilters({
          estado: '', fechaDesde: '', fechaHasta: '', searchTerm: ''
        })}
        searchPlaceholder="Buscar por ID de orden, mantenimiento o repuesto..."
      >
        <CustomSelect
          name="estado"
          value={filters.estado}
          onChange={handleFilterChange}
          placeholder="Todos los estados"
          options={Object.entries(estadosOrden).map(([key, info]) => ({
            value: key,
            label: info.label
          }))}
          className="w-full md:min-w-[180px] md:w-auto"
        />
        
        {/* Filtro de proveedor removido - solo teknoParts */}

        <input
          type="date"
          name="fechaDesde"
          value={filters.fechaDesde}
          onChange={handleFilterChange}
          className="px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm"
          placeholder="Fecha desde"
        />

        <input
          type="date"
          name="fechaHasta"
          value={filters.fechaHasta}
          onChange={handleFilterChange}
          className="px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm"
          placeholder="Fecha hasta"
        />
      </FilterBar>

      {/* Lista de órdenes */}
      {loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {filteredOrdenes.map(orden => {
            const estadoInfo = getEstadoInfo(orden.estado);
            const IconoEstado = estadoInfo.icon;
            
            // Determinar color del borde según estado
            const getBorderColor = (estado) => {
              switch (estado) {
                case 'pendiente':
                  return 'bg-yellow-500';
                case 'en_proceso':
                  return 'bg-blue-500';
                case 'entregado':
                  return 'bg-green-500';
                case 'cancelado':
                  return 'bg-red-500';
                default:
                  return 'bg-gray-500';
              }
            };

            return (
              <div key={orden.id} className="bg-gray-800 rounded-lg flex flex-col border border-gray-700 hover:border-gray-600 transition-all duration-200 shadow-sm relative overflow-hidden">
                <div className={`${getBorderColor(orden.estado)} w-1 h-full absolute left-0 top-0 bottom-0 rounded-l-md`}></div>
                
                {/* Cuerpo de la tarjeta */}
                <div className="flex-grow p-4">
                  {/* Primera fila: ID y estado */}
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      <FaTruck className="mr-2 text-blue-400" />
                      <span className="font-medium">{orden.id}</span>
                      <span className="text-gray-400 ml-2 text-sm">
                        {calcularTiempoTranscurrido(orden.fecha_pedido)}
                      </span>
                    </div>
                    
                    <div className="flex items-center gap-2">
                      <Badge variant={estadoInfo.variant} size="sm">
                        <IconoEstado className="mr-1" />
                        {estadoInfo.label}
                      </Badge>
                      
                      {orden.problema && (
                        <Badge variant="danger" size="sm">
                          <FaExclamationTriangle className="mr-1" />
                          Problema
                        </Badge>
                      )}
                    </div>
                  </div>

                  {/* Segunda fila: información del proveedor y total */}
                  <div className="flex justify-between items-center mb-3">
                    <div className="flex flex-wrap items-center gap-2 flex-1">
                      {/* Proveedor */}
                      <div className="inline-flex items-center bg-gray-700 bg-opacity-50 rounded-md px-2 py-1">
                        <img 
                          src={orden.proveedor.logo} 
                          alt={orden.proveedor.nombre}
                          className="w-4 h-4 rounded mr-1"
                        />
                        <span className="font-medium text-sm">{orden.proveedor.nombre}</span>
                      </div>

                      {/* Número de orden del proveedor */}
                      <div className="inline-flex items-center bg-gray-700 bg-opacity-50 rounded-md px-2 py-1">
                        <FaBox className="mr-1 text-purple-400" size={12} />
                        <span className="font-medium text-sm">{orden.numero_orden_proveedor}</span>
                      </div>

                      {/* Mantenimiento asociado */}
                      {orden.mantenimiento_id && (
                        <div className="inline-flex items-center bg-gray-700 bg-opacity-50 rounded-md px-2 py-1">
                          <FaWrench className="mr-1 text-green-400" size={12} />
                          <span className="font-medium text-sm">{orden.mantenimiento_id}</span>
                        </div>
                      )}
                    </div>
                    
                    <span className="text-sm font-bold text-green-400 flex items-center">
                      <FaDollarSign className="mr-1" size={10} />
                      {orden.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                    </span>
                  </div>

                  {/* Tercera fila: información de fechas y tracking */}
                  <div className="mt-3 space-y-2">
                    {/* Fechas */}
                    <div className="flex items-center bg-gray-700 bg-opacity-50 rounded-md px-2 py-1">
                      <FaCalendarAlt className="mr-1 text-blue-400" size={12} />
                      <span className="font-medium text-sm mr-2">Fechas:</span>
                      <div className="flex flex-wrap gap-1">
                        <Badge variant="info" size="sm">
                          Pedido: {formatFecha(orden.fecha_pedido).split(' ')[0]}
                        </Badge>
                        {orden.fecha_entrega_estimada && (
                          <Badge variant="warning" size="sm">
                            Est: {formatFecha(orden.fecha_entrega_estimada).split(' ')[0]}
                          </Badge>
                        )}
                        {orden.fecha_entrega_real && (
                          <Badge variant="success" size="sm">
                            Entregado: {formatFecha(orden.fecha_entrega_real).split(' ')[0]}
                          </Badge>
                        )}
                      </div>
                    </div>

                    {/* Tracking info */}
                    {orden.tracking && (
                      <div className="flex items-center bg-gray-700 bg-opacity-50 rounded-md px-2 py-1">
                        <FaTruck className="mr-1 text-blue-400" size={12} />
                        <span className="font-medium text-sm mr-2">Tracking:</span>
                        <div className="flex flex-wrap gap-1">
                          <Badge variant="primary" size="sm">
                            {orden.tracking.transportista} - {orden.tracking.numero_guia}
                          </Badge>
                        </div>
                      </div>
                    )}

                    {/* Repuestos pedidos */}
                    <div className="flex items-center bg-gray-700 bg-opacity-50 rounded-md px-2 py-1">
                      <FaCog className="mr-1 text-orange-400" size={12} />
                      <span className="font-medium text-sm mr-2">Repuestos:</span>
                      <div className="flex flex-wrap gap-1">
                        {orden.items.slice(0, 2).map((item, index) => (
                          <Badge key={index} variant="warning" size="sm">
                            {item.nombre} ({item.cantidad}x)
                          </Badge>
                        ))}
                        {orden.items.length > 2 && (
                          <Badge variant="secondary" size="sm">
                            +{orden.items.length - 2} más
                          </Badge>
                        )}
                      </div>
                    </div>

                    {/* Problema info */}
                    {orden.problema && (
                      <div className="flex items-center bg-red-900/20 rounded-md px-2 py-1">
                        <FaExclamationTriangle className="mr-1 text-red-400" size={12} />
                        <span className="font-medium text-sm mr-2 text-red-200">Problema:</span>
                        <Badge variant="danger" size="sm">
                          {orden.problema.descripcion}
                        </Badge>
                      </div>
                    )}
                  </div>

                  {/* Cuarta fila: items y acciones */}
                  <div className="flex justify-between items-center mt-3">
                    <div className="flex items-center space-x-2">
                      <Badge variant="secondary" size="sm">
                        <FaBox className="mr-1" size={10} />
                        {orden.items.length} repuesto{orden.items.length > 1 ? 's' : ''}
                      </Badge>
                    </div>
                    
                    <div className="flex gap-2">
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleVerDetalle(orden)}
                        icon={<FaEye />}
                      >
                        Ver
                      </Button>
                      
                      {orden.estado === 'entregado' && (
                        <Button
                          variant="success"
                          size="sm"
                          onClick={() => handleAgregarAInventario(orden)}
                          icon={<FaBox />}
                        >
                          <span className="hidden sm:inline">A Inventario</span>
                          <span className="sm:hidden">Inv</span>
                        </Button>
                      )}
                      
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => handleSyncOrden(orden.id)}
                        icon={<FaSync />}
                      >
                        Sync
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {filteredOrdenes.length === 0 && !loading && (
        <div className="text-center py-12">
          <FaTruck className="mx-auto text-6xl text-gray-600 mb-4" />
          <h3 className="text-xl font-semibold mb-2">No se encontraron órdenes</h3>
          <p className="text-gray-400">Intenta ajustar los filtros de búsqueda</p>
        </div>
      )}

      {/* Modal de detalle */}
      {selectedOrden && (
        <DetalleOrdenModal
          isOpen={showDetalleModal}
          onClose={() => {
            setShowDetalleModal(false);
            setSelectedOrden(null);
          }}
          orden={selectedOrden}
          onSync={() => handleSyncOrden(selectedOrden.id)}
        />
      )}

      {/* Modal para agregar al inventario */}
      {ordenParaInventario && (
        <AgregarInventarioModal
          isOpen={showInventarioModal}
          onClose={() => {
            setShowInventarioModal(false);
            setOrdenParaInventario(null);
          }}
          orden={ordenParaInventario}
          onSuccess={() => {
            setShowInventarioModal(false);
            setOrdenParaInventario(null);
            toastService.success('Repuestos agregados al inventario local');
          }}
        />
      )}
    </div>
  );
};

// Componente del modal de detalle
const DetalleOrdenModal = ({ isOpen, onClose, orden, onSync }) => {
  if (!orden) return null;

  const estadoInfo = {
    pendiente: { label: 'Pendiente', variant: 'warning', icon: FaClock },
    en_proceso: { label: 'En Proceso', variant: 'primary', icon: FaTruck },
    entregado: { label: 'Entregado', variant: 'success', icon: FaCheck },
    cancelado: { label: 'Cancelado', variant: 'danger', icon: FaExclamationTriangle }
  };

  const currentEstado = estadoInfo[orden.estado];
  const IconoEstado = currentEstado.icon;

  const formatFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Detalle de Orden ${orden.id}`}
      size="xl"
      headerExtra={
        <Badge variant={currentEstado.variant}>
          <IconoEstado className="mr-1" />
          {currentEstado.label}
        </Badge>
      }
    >
      <div className="space-y-6">
        {/* Información general */}
        <Card className="bg-gray-800">
          <CardBody className="p-4">
            <h4 className="font-semibold mb-3">Información General</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div>
                <span className="text-gray-400">ID Orden:</span>
                <p className="font-medium">{orden.id}</p>
              </div>
              <div>
                <span className="text-gray-400">Orden Proveedor:</span>
                <p className="font-medium">{orden.numero_orden_proveedor}</p>
              </div>
              <div>
                <span className="text-gray-400">Fecha Pedido:</span>
                <p className="font-medium">{formatFecha(orden.fecha_pedido)}</p>
              </div>
              <div>
                <span className="text-gray-400">Entrega Estimada:</span>
                <p className="font-medium">
                  {orden.fecha_entrega_estimada ? formatFecha(orden.fecha_entrega_estimada) : 'No definida'}
                </p>
              </div>
              {orden.mantenimiento_id && (
                <div>
                  <span className="text-gray-400">Mantenimiento:</span>
                  <p className="font-medium">{orden.mantenimiento_id}</p>
                </div>
              )}
              <div>
                <span className="text-gray-400">Total:</span>
                <p className="font-medium text-green-400">${orden.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</p>
              </div>
            </div>
          </CardBody>
        </Card>

        {/* Información del proveedor */}
        <Card className="bg-gray-800">
          <CardBody className="p-4">
            <h4 className="font-semibold mb-3">Proveedor</h4>
            <div className="flex items-center mb-3">
              <img 
                src={orden.proveedor.logo} 
                alt={orden.proveedor.nombre}
                className="w-12 h-12 rounded mr-3"
              />
              <div>
                <p className="font-medium">{orden.proveedor.nombre}</p>
                <p className="text-sm text-gray-400">{orden.proveedor.email}</p>
              </div>
            </div>
            <div className="text-sm text-gray-400">
              <p>Teléfono: {orden.proveedor.telefono}</p>
            </div>
          </CardBody>
        </Card>

        {/* Items de la orden */}
        <Card className="bg-gray-800">
          <CardBody className="p-4">
            <h4 className="font-semibold mb-3">Repuestos Pedidos</h4>
            <div className="space-y-3">
              {orden.items.map(item => (
                <div key={item.id} className="flex gap-3 p-3 bg-gray-700 rounded">
                  <img 
                    src={item.imagen} 
                    alt={item.nombre}
                    className="w-16 h-16 object-cover rounded"
                  />
                  <div className="flex-1">
                    <h5 className="font-medium">{item.nombre}</h5>
                    <p className="text-sm text-gray-400">Código: {item.codigo_proveedor}</p>
                    <div className="flex justify-between items-center mt-2">
                      <span className="text-sm">Cantidad: {item.cantidad}</span>
                      <div className="text-right">
                        <p className="font-medium">${(item.precio_final * item.cantidad).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</p>
                        <p className="text-xs text-gray-400">${item.precio_final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} c/u</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="border-t border-gray-600 pt-3 mt-3">
              <div className="flex justify-between text-sm">
                <span className="text-gray-400">Comisión aplicada:</span>
                <span className="text-blue-400">${orden.comision_aplicada.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</span>
              </div>
              <div className="flex justify-between font-semibold text-lg mt-2">
                <span>Total:</span>
                <span className="text-green-400">${orden.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</span>
              </div>
            </div>
          </CardBody>
        </Card>

        {/* Información de tracking */}
        {orden.tracking && (
          <Card className="bg-blue-900/20 border-blue-800/50">
            <CardBody className="p-4">
              <h4 className="font-semibold mb-3 text-blue-200">Información de Envío</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <div>
                  <span className="text-blue-300">Transportista:</span>
                  <p className="font-medium text-white">{orden.tracking.transportista}</p>
                </div>
                <div>
                  <span className="text-blue-300">Número de Guía:</span>
                  <p className="font-medium text-white">{orden.tracking.numero_guia}</p>
                </div>
              </div>
              <div className="mt-3">
                <a 
                  href={orden.tracking.url_tracking}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-blue-400 hover:text-blue-300"
                >
                  <FaTruck className="mr-2" />
                  Ver seguimiento en tiempo real →
                </a>
              </div>
            </CardBody>
          </Card>
        )}

        {/* Información de problema */}
        {orden.problema && (
          <Card className="bg-red-900/20 border-red-800/50">
            <CardBody className="p-4">
              <h4 className="font-semibold mb-3 text-red-200">Problema Reportado</h4>
              <div className="space-y-3">
                <div>
                  <span className="text-red-300">Descripción:</span>
                  <p className="font-medium text-white">{orden.problema.descripcion}</p>
                </div>
                <div>
                  <span className="text-red-300">Reportado:</span>
                  <p className="font-medium text-white">{formatFecha(orden.problema.fecha_reporte)}</p>
                </div>
                {orden.problema.acciones_sugeridas && (
                  <div>
                    <span className="text-red-300">Acciones Sugeridas:</span>
                    <ul className="list-disc list-inside text-white mt-1">
                      {orden.problema.acciones_sugeridas.map((accion, index) => (
                        <li key={index} className="text-sm">{accion}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        )}

        {/* Historial de la orden */}
        <Card className="bg-gray-800">
          <CardBody className="p-4">
            <h4 className="font-semibold mb-3">Historial de Estados</h4>
            <div className="space-y-3">
              {orden.historial.map((evento, index) => {
                const eventoEstado = estadoInfo[evento.estado];
                const EventoIcon = eventoEstado?.icon || FaClock;
                
                return (
                  <div key={index} className="flex gap-3">
                    <div className={`w-8 h-8 rounded-full bg-${eventoEstado?.variant === 'primary' ? 'blue' : 
                                     eventoEstado?.variant === 'success' ? 'green' :
                                     eventoEstado?.variant === 'warning' ? 'yellow' :
                                     eventoEstado?.variant === 'danger' ? 'red' :
                                     eventoEstado?.variant === 'info' ? 'blue' : 'gray'}-600 
                                   flex items-center justify-center flex-shrink-0`}>
                      <EventoIcon className="text-white text-sm" />
                    </div>
                    <div className="flex-1">
                      <div className="flex justify-between items-start">
                        <div>
                          <p className="font-medium">{eventoEstado?.label || 'Estado'}</p>
                          <p className="text-sm text-gray-400">{evento.descripcion}</p>
                          <p className="text-xs text-gray-500">Por: {evento.usuario}</p>
                        </div>
                        <span className="text-xs text-gray-500">
                          {formatFecha(evento.fecha)}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </CardBody>
        </Card>

        {/* Botones de acción */}
        <div className="flex gap-3">
          <Button
            variant="secondary"
            onClick={onSync}
            icon={<FaSync />}
          >
            Sincronizar Estado
          </Button>
          <Button
            variant="primary"
            onClick={onClose}
            className="flex-1"
          >
            Cerrar
          </Button>
        </div>
      </div>
    </Modal>
  );
};

// Componente del modal para agregar repuestos al inventario
const AgregarInventarioModal = ({ isOpen, onClose, orden, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [repuestosSeleccionados, setRepuestosSeleccionados] = useState({});

  useEffect(() => {
    if (isOpen && orden) {
      // Inicializar todos los repuestos como seleccionados con su cantidad original
      const inicial = {};
      orden.items.forEach(item => {
        inicial[item.id] = {
          seleccionado: true,
          cantidadRecibida: item.cantidad,
          cantidadOriginal: item.cantidad,
          ubicacion: 'A-01', // Ubicación por defecto
          observaciones: ''
        };
      });
      setRepuestosSeleccionados(inicial);
    }
  }, [isOpen, orden]);

  const handleCantidadChange = (itemId, cantidad) => {
    setRepuestosSeleccionados(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        cantidadRecibida: Math.max(0, Math.min(cantidad, prev[itemId].cantidadOriginal))
      }
    }));
  };

  const handleUbicacionChange = (itemId, ubicacion) => {
    setRepuestosSeleccionados(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        ubicacion
      }
    }));
  };

  const handleObservacionesChange = (itemId, observaciones) => {
    setRepuestosSeleccionados(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        observaciones
      }
    }));
  };

  const toggleRepuesto = (itemId) => {
    setRepuestosSeleccionados(prev => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        seleccionado: !prev[itemId].seleccionado
      }
    }));
  };

  const handleConfirmar = async () => {
    setLoading(true);
    try {
      const repuestosParaAgregar = Object.entries(repuestosSeleccionados)
        .filter(([id, data]) => data.seleccionado && data.cantidadRecibida > 0)
        .map(([id, data]) => {
          const item = orden.items.find(i => i.id == id);
          return {
            repuesto_id: item.id,
            nombre: item.nombre,
            codigo: item.codigo_proveedor,
            cantidad: data.cantidadRecibida,
            precio_unitario: item.precio_final,
            ubicacion: data.ubicacion,
            observaciones: data.observaciones,
            proveedor: orden.proveedor.nombre,
            orden_id: orden.id,
            fecha_ingreso: new Date().toISOString()
          };
        });

      // Simular llamada API para agregar al inventario
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      //console.log('Repuestos a agregar al inventario:', repuestosParaAgregar);
      onSuccess();
      
    } catch (error) {
      toastService.error('Error al agregar repuestos al inventario');
    } finally {
      setLoading(false);
    }
  };

  const repuestosSeleccionadosCount = Object.values(repuestosSeleccionados)
    .filter(data => data.seleccionado && data.cantidadRecibida > 0).length;

  if (!orden) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Agregar Repuestos al Inventario Local"
      size="xl"
      headerExtra={
        <Badge variant="info">
          <FaBox className="mr-1" />
          Orden {orden.id}
        </Badge>
      }
    >
      <div className="space-y-4">
        <div className="bg-blue-900/20 border border-blue-800/50 rounded-lg p-4">
          <h4 className="font-medium text-blue-200 mb-2">Información de la Orden</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-400">Proveedor:</span>
              <span className="ml-2 font-medium">{orden.proveedor.nombre}</span>
            </div>
            <div>
              <span className="text-gray-400">Fecha entrega:</span>
              <span className="ml-2 font-medium">
                {new Date(orden.fecha_entrega_real).toLocaleDateString('es-CL')}
              </span>
            </div>
            <div>
              <span className="text-gray-400">Total items:</span>
              <span className="ml-2 font-medium">{orden.items.length} repuestos</span>
            </div>
            <div>
              <span className="text-gray-400">Seleccionados:</span>
              <span className="ml-2 font-medium text-green-400">{repuestosSeleccionadosCount}</span>
            </div>
          </div>
        </div>

        <div className="max-h-96 overflow-y-auto space-y-3">
          {orden.items.map(item => {
            const repuestoData = repuestosSeleccionados[item.id] || {};
            const isSelected = repuestoData.seleccionado;
            
            return (
              <Card 
                key={item.id} 
                className={`transition-all duration-200 ${
                  isSelected ? 'border-green-500/50 bg-green-900/10' : 'border-gray-600'
                }`}
              >
                <CardBody className="p-4">
                  <div className="flex items-start gap-3">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => toggleRepuesto(item.id)}
                        className="w-4 h-4 text-green-600 bg-gray-700 border-gray-600 rounded focus:ring-green-500"
                      />
                    </div>
                    
                    <div className="flex-1 space-y-3">
                      <div>
                        <h5 className="font-medium">{item.nombre}</h5>
                        <p className="text-sm text-gray-400">Código: {item.codigo_proveedor}</p>
                      </div>
                      
                      {isSelected && (
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                          <div>
                            <label className="block text-xs font-medium text-gray-400 mb-1">
                              Cantidad Recibida
                            </label>
                            <input
                              type="number"
                              min="0"
                              max={repuestoData.cantidadOriginal}
                              value={repuestoData.cantidadRecibida || 0}
                              onChange={(e) => handleCantidadChange(item.id, parseInt(e.target.value))}
                              className="w-full px-3 py-1 bg-gray-800 border border-gray-600 rounded text-sm"
                            />
                            <p className="text-xs text-gray-500 mt-1">
                              Máx: {repuestoData.cantidadOriginal}
                            </p>
                          </div>
                          
                          <div>
                            <label className="block text-xs font-medium text-gray-400 mb-1">
                              Ubicación
                            </label>
                            <input
                              type="text"
                              value={repuestoData.ubicacion || ''}
                              onChange={(e) => handleUbicacionChange(item.id, e.target.value)}
                              placeholder="Ej: A-01, B-15"
                              className="w-full px-3 py-1 bg-gray-800 border border-gray-600 rounded text-sm"
                            />
                          </div>
                          
                          <div>
                            <label className="block text-xs font-medium text-gray-400 mb-1">
                              Observaciones
                            </label>
                            <input
                              type="text"
                              value={repuestoData.observaciones || ''}
                              onChange={(e) => handleObservacionesChange(item.id, e.target.value)}
                              placeholder="Opcional"
                              className="w-full px-3 py-1 bg-gray-800 border border-gray-600 rounded text-sm"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    
                    <div className="text-right">
                      <p className="text-sm font-medium">${item.precio_final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}</p>
                      <p className="text-xs text-gray-400">c/u</p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            );
          })}
        </div>

        <div className="flex justify-end gap-3 pt-4 border-t border-gray-700">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirmar}
            loading={loading}
            disabled={repuestosSeleccionadosCount === 0}
            icon={<FaBox />}
          >
            Agregar {repuestosSeleccionadosCount} al Inventario
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SeguimientoOrdenesExternas;